var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareEmail = function SvgShareEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "shareEmail_svg__sc-gKsewC shareEmail_svg__fzJjte",
    "data-testid": "ShareIcon-email",
    viewBox: "0 0 48 48"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#60696C",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.154 26.568a.5.5 0 0 0 .692 0l1.416-1.354 5.192 4.976a.5.5 0 0 0 .692-.722l-5.16-4.946 5.228-4.997a.5.5 0 0 0-.691-.723l-5.582 5.336a1 1 0 0 0-.048.045L24.5 25.515l-1.386-1.325a1 1 0 0 0-.062-.059l-5.575-5.329a.5.5 0 1 0-.691.723l5.229 4.998-5.162 4.947a.5.5 0 1 0 .695.721l5.19-4.976z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M35 29.318a3.683 3.683 0 0 1-3.679 3.68H17.679A3.683 3.683 0 0 1 14 29.317v-9.642a3.683 3.683 0 0 1 3.679-3.679h13.642A3.683 3.683 0 0 1 35 19.677zm-17.321-12.32A2.68 2.68 0 0 0 15 19.675v9.642a2.68 2.68 0 0 0 2.679 2.68h13.642A2.68 2.68 0 0 0 34 29.317v-9.642a2.68 2.68 0 0 0-2.679-2.679z",
    clipRule: "evenodd"
  })));
};
export default SvgShareEmail;